export interface ResourceSite {
  id: string;
  name: string;
  url: string;
  description: string;
  category: string;
  tags: string[];
  rating: number;
  featured: boolean;
  logoUrl: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'download',
    name: '免费下载',
    description: '提供galgame游戏本体免费下载的资源站点，涵盖日系原版与汉化版本',
    icon: 'ri-download-cloud-2-line',
  },
  {
    slug: 'chinese-patch',
    name: '汉化资源',
    description: '专注于galgame汉化补丁、中文翻译资源汇总的社区与站点',
    icon: 'ri-translate',
  },
  {
    slug: 'guide',
    name: '攻略指南',
    description: 'galgame全路线攻略、选项分支指南与角色攻略合集',
    icon: 'ri-book-read-line',
  },
  {
    slug: 'patch',
    name: '补丁工具',
    description: 'galgame运行补丁、免CD补丁、文字提取工具与模拟器资源',
    icon: 'ri-tools-line',
  },
  {
    slug: 'community',
    name: '社区论坛',
    description: 'galgame玩家交流社区、讨论区与资源分享平台',
    icon: 'ri-group-line',
  },
];

export const sites: ResourceSite[] = [
  {
    id: 'site-1',
    name: '绯月Galgame',
    url: 'https://example.com/feiyue',
    description: '国内最大的galgame综合社区，提供海量游戏下载、汉化补丁、攻略讨论与玩家交流，资源覆盖面广，更新速度快，是galgame爱好者的一站式平台。',
    category: 'download',
    tags: ['galgame下载', '汉化资源', '社区论坛'],
    rating: 4.9,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Japanese%20visual%20novel%20anime%20style%20website%20logo%20with%20cherry%20blossom%20petals%2C%20clean%20minimal%20design%2C%20warm%20pink%20and%20white%20color%20palette%2C%20elegant%20typography%2C%20soft%20gradient%20background&width=120&height=120&seq=logo-site-1&orientation=squarish',
  },
  {
    id: 'site-2',
    name: '恋爱游戏网',
    url: 'https://example.com/lianai',
    description: '专注于日系恋爱冒险游戏的资源站点，收录超过2000款galgame作品，提供详细的游戏介绍、截图预览与下载链接，支持按类型、会社、评分筛选。',
    category: 'download',
    tags: ['日系galgame', '游戏下载', '游戏介绍'],
    rating: 4.7,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Romantic%20visual%20novel%20game%20website%20logo%2C%20soft%20pink%20and%20white%20flowers%2C%20anime%20art%20style%2C%20beautiful%20sakura%20petals%2C%20clean%20Japanese%20aesthetic&width=120&height=120&seq=logo-site-2&orientation=squarish',
  },
  {
    id: 'site-3',
    name: 'Galgame汉化组联合',
    url: 'https://example.com/hanhua',
    description: '由多个galgame汉化组联合运营的资源站，第一时间发布汉化补丁与中文硬盘版，支持补丁版本管理与更新提醒，是汉化资源的核心集散地。',
    category: 'chinese-patch',
    tags: ['汉化补丁', '汉化组', '中文硬盘版'],
    rating: 4.8,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Chinese%20localization%20team%20logo%20with%20kanji%20and%20brush%20stroke%20design%2C%20traditional%20ink%20wash%20painting%20style%2C%20red%20stamp%20seal%2C%20elegant%20black%20and%20gold%20color%20scheme&width=120&height=120&seq=logo-site-3&orientation=squarish',
  },
  {
    id: 'site-4',
    name: 'ACG资源库',
    url: 'https://example.com/acg',
    description: 'ACG综合资源站，galgame专区提供大量汉化硬盘版游戏、全CG存档与原声音乐下载，资源分类清晰，下载方式多样，支持网盘与BT下载。',
    category: 'download',
    tags: ['galgame硬盘版', '全CG存档', '原声音乐'],
    rating: 4.5,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=ACG%20anime%20game%20resource%20website%20logo%2C%20colorful%20anime%20character%20silhouette%2C%20vibrant%20manga%20style%2C%20fun%20and%20energetic%20design%2C%20bright%20orange%20and%20cyan%20accents&width=120&height=120&seq=logo-site-4&orientation=squarish',
  },
  {
    id: 'site-5',
    name: 'Galgame攻略Wiki',
    url: 'https://example.com/wiki',
    description: '最全面的galgame攻略维基站，收录数千款游戏的完整攻略，包含流程图式的选项分支攻略、角色攻略路线与隐藏要素解锁方法。',
    category: 'guide',
    tags: ['攻略wiki', '路线攻略', '选项指南'],
    rating: 4.8,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Wiki%20style%20visual%20novel%20guide%20website%20logo%2C%20clean%20and%20organized%20design%2C%20flowchart%20elements%2C%20pastel%20color%20scheme%2C%20reading%20glasses%20and%20book%20motif%2C%20scholarly%20aesthetic&width=120&height=120&seq=logo-site-5&orientation=squarish',
  },
  {
    id: 'site-6',
    name: '星空论坛Galgame区',
    url: 'https://example.com/xingkong',
    description: '老牌ACG论坛的galgame专区，沉淀了十余年的资源与讨论，拥有大量资深玩家发布的深度评测、剧情分析与资源整理帖。',
    category: 'community',
    tags: ['论坛社区', '深度评测', '剧情分析'],
    rating: 4.6,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=Starry%20sky%20forum%20logo%20with%20constellation%20stars%2C%20anime%20girl%20stargazing%20silhouette%2C%20deep%20navy%20blue%20and%20gold%20stars%2C%20dreamy%20atmospheric%20design&width=120&height=120&seq=logo-site-6&orientation=squarish',
  },
  {
    id: 'site-7',
    name: '极客Galgame工具站',
    url: 'https://example.com/geek',
    description: '提供galgame运行所需的各类工具与补丁，包括Locale Emulator使用教程、免CD补丁合集、文字提取器与存档修改器，解决游戏运行中的各种技术问题。',
    category: 'patch',
    tags: ['运行补丁', '工具合集', '技术教程'],
    rating: 4.4,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=Technology%20tool%20website%20logo%20with%20gear%20and%20wrench%20icons%2C%20clean%20modern%20design%2C%20green%20circuit%20board%20pattern%2C%20technical%20minimalist%20aesthetic&width=120&height=120&seq=logo-site-7&orientation=squarish',
  },
  {
    id: 'site-8',
    name: '月幕Galgame',
    url: 'https://example.com/yuemu',
    description: '新兴的galgame资源与资讯站点，界面设计精美，提供游戏评分、推荐榜单、新作资讯与资源下载，用户体验极佳，深受新老玩家喜爱。',
    category: 'download',
    tags: ['游戏推荐', '新作资讯', '评分榜单'],
    rating: 4.7,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Moonlight%20curtain%20themed%20visual%20novel%20website%20logo%2C%20elegant%20theater%20curtain%20design%20with%20moon%2C%20deep%20purple%20and%20silver%20color%2C%20luxurious%20romantic%20aesthetic&width=120&height=120&seq=logo-site-8&orientation=squarish',
  },
  {
    id: 'site-9',
    name: '红茶汉化组',
    url: 'https://example.com/blacktea',
    description: '知名galgame汉化组的官方站点，以翻译质量高、更新稳定著称，已完成多部经典作品的汉化工作，并提供汉化版游戏直接下载。',
    category: 'chinese-patch',
    tags: ['汉化组', '经典汉化', '高质量翻译'],
    rating: 4.9,
    featured: true,
    logoUrl: 'https://readdy.ai/api/search-image?query=Tea%20themed%20translation%20group%20logo%20with%20teacup%20and%20steam%2C%20British%20afternoon%20tea%20aesthetic%2C%20warm%20brown%20and%20cream%20color%2C%20cozy%20reading%20atmosphere&width=120&height=120&seq=logo-site-9&orientation=squarish',
  },
  {
    id: 'site-10',
    name: 'Galgame存档库',
    url: 'https://example.com/save',
    description: '专注于galgame全CG存档分享的平台，支持按游戏名称搜索存档文件，覆盖超过1500款作品，帮助玩家快速解锁全部CG与剧情。',
    category: 'patch',
    tags: ['全CG存档', '存档下载', '存档管理'],
    rating: 4.3,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=Save%20file%20archive%20logo%20with%20floppy%20disk%20and%20folder%20icons%2C%20nostalgic%20retro%20design%2C%20warm%20amber%20and%20cream%20color%2C%20organized%20archive%20aesthetic&width=120&height=120&seq=logo-site-10&orientation=squarish',
  },
  {
    id: 'site-11',
    name: '琉璃神社Galgame分部',
    url: 'https://example.com/liuli',
    description: '知名同人资源站的galgame专属分区，提供大量同人galgame与独立视觉小说资源下载，涵盖各种题材与风格，适合寻找小众精品的玩家。',
    category: 'download',
    tags: ['同人galgame', '独立游戏', '小众精品'],
    rating: 4.5,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=Crystal%20glass%20shrine%20themed%20logo%20with%20stained%20glass%20effect%2C%20Japanese%20shrine%20architecture%2C%20mystical%20atmosphere%2C%20vibrant%20multi%20color%20light%20refraction&width=120&height=120&seq=logo-site-11&orientation=squarish',
  },
  {
    id: 'site-12',
    name: 'Galgame情报局',
    url: 'https://example.com/qingbao',
    description: '追踪galgame业界最新动态的资讯站点，第一时间报道新作发布、汉化进度、会社新闻与活动情报，是了解galgame圈最新动向的必备平台。',
    category: 'community',
    tags: ['业界资讯', '新作情报', '汉化进度'],
    rating: 4.6,
    featured: false,
    logoUrl: 'https://readdy.ai/api/search-image?query=News%20intelligence%20agency%20logo%20with%20newspaper%20and%20magnifying%20glass%2C%20modern%20press%20design%2C%20clean%20black%20and%20white%20with%20red%20accent%2C%20journalistic%20vibe&width=120&height=120&seq=logo-site-12&orientation=squarish',
  },
];

export const featuredSites = sites.filter((s) => s.featured);